import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth';
import './styles.css';
import './enhancements.css';
import './candidate07.css';
import './candidate08.css';
import './candidate09.css';
import './candidate10.css';
import './candidate15.css';
import './candidate16.css';
import './candidate17.css';
import './candidate18.css';
import './candidate19.css';
import './candidate20.css';
import './candidate21.css';
import './candidate22.css';
import './candidate23.css';
import './candidate23r2.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><BrowserRouter><AuthProvider><App/></AuthProvider></BrowserRouter></React.StrictMode>);
